import React from "react";
import styles from "./Footer.module.css";
import { useSidebarToggle } from "context/ToggleSideBarContext";

interface FooterProps {
  children: React.ReactNode;
}

const Footer: React.FC<FooterProps> = ({ children }) => {
  const { isSideBarOpen } = useSidebarToggle();
  return (
    <footer
      className={`${styles.footer} ${isSideBarOpen ? styles.footerShifted : styles.footerUnshifted}`}
    >
      {children}
    </footer>
  );
};

export default Footer;
